import { useAuth } from "context/AuthProvider";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  Table,
} from "reactstrap";
import { apiNotificacionesService } from "services/apiNotificacionesService";
const MostrarNotidciaciones = () => {
  const { empresa } = useAuth();
  const navigate = useNavigate();
  const [notificacionesSistema, setNotificacionesSistema] = useState([]);
  const [loadingSistema, setLoadingSistema] = useState(false);

  const cargarNotificacionesSistema = useCallback(async () => {
    if (!empresa?.id) {
      return;
    }

    setLoadingSistema(true);
    try {
      const response = await apiNotificacionesService.getAllByEmpresa(empresa.id);
      if (!response.ok) {
        setNotificacionesSistema([]);
        return;
      }
      const data = await response.json();
      setNotificacionesSistema(Array.isArray(data) ? data : []);
    } finally {
      setLoadingSistema(false);
    }
  }, [empresa?.id]);

  useEffect(() => {
    cargarNotificacionesSistema();
  }, [cargarNotificacionesSistema]);

  const onMarcarLeida = async (notificacionId) => {
    if (!empresa?.id) {
      return;
    }
    const response = await apiNotificacionesService.marcarLeida(
      empresa.id,
      notificacionId
    );
    if (response.ok) {
      setNotificacionesSistema((prev) =>
        prev.map((item) =>
          item.id === notificacionId ? { ...item, leida: true } : item
        )
      );
    }
  };

  const onEliminar = async (notificacionId) => {
    if (!empresa?.id) {
      return;
    }
    const response = await apiNotificacionesService.eliminar(
      empresa.id,
      notificacionId
    );
    if (response.ok) {
      setNotificacionesSistema((prev) =>
        prev.filter((item) => item.id !== notificacionId)
      );
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) {
      return "-";
    }
    const parsed = new Date(fecha);
    if (Number.isNaN(parsed.getTime())) {
      return fecha;
    }
    return parsed.toLocaleString("es-ES");
  };

  const esCategoriaAusencias = (categoria) => {
    if (!categoria) {
      return false;
    }
    const normalizada = String(categoria).toUpperCase();
    return (
      normalizada === "AUSENCIA" ||
      normalizada === "AUSENCIAS" ||
      normalizada === "ASUENCIAS"
    );
  };

  const onTramitar = (empleadoId) => {
    if (!empleadoId) {
      return;
    }
    navigate(`/admin/solicitudes/${empleadoId}`);
  };

  return (
    <Card>
      <CardHeader>Notificaciones</CardHeader>
      <CardBody className="p-0">
        <Table
          className="mb-0"
          responsive
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <thead className="thead-light">
            <tr>
              <th style={{ width: "16%" }}>Fecha</th>
              <th style={{ width: "18%" }}>Titulo</th>
              <th style={{ width: "36%" }}>Mensaje</th>
              <th style={{ width: "30%" }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {!loadingSistema && notificacionesSistema.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center text-muted">
                  Sin notificaciones
                </td>
              </tr>
            )}
            {notificacionesSistema.map((notificacion) => (
              <tr key={notificacion.id}>
                <td
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",
                  }}
                >
                  {formatearFecha(notificacion.fecha)}
                </td>
                <td
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",
                  }}
                >
                  {notificacion.titulo}
                </td>
                <td
                  style={{
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    whiteSpace: "normal",
                  }}
                >
                  {notificacion.mensaje}
                </td>
              
                <td>
                  <Button
                    color="danger"
                    size="sm"
                    className="btn-icon-only"
                    onClick={() => onEliminar(notificacion.id)}
                    title="Eliminar"
                    aria-label="Eliminar"
                  >
                    <i className="fas fa-trash" />
                  </Button>
                  {esCategoriaAusencias(notificacion.categoria) && (
                    <Button
                      color="primary"
                      size="sm"
                      className="ml-2"
                      onClick={() => onTramitar(notificacion.empleadoId)}
                      title="Tramitar solicitud"
                      aria-label="Tramitar solicitud"
                      disabled={!notificacion.empleadoId}
                    >
                      Tramitar
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default MostrarNotidciaciones;

